export const blogPosts = [
  {
    id: "understanding-gst-compliance-2024",
    title: "Understanding GST Compliance in 2024",
    excerpt: "A comprehensive guide to GST compliance requirements and recent updates for businesses.",
    content: `
      <p class="mb-6 text-lg leading-relaxed">GST compliance has become increasingly important for businesses in 2024. With new regulations and digital transformation initiatives, staying compliant is more crucial than ever.</p>
      
      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Key Changes in GST Compliance</h2>
      <p class="mb-4 text-lg leading-relaxed">The government has introduced several new measures to streamline GST compliance:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Enhanced digital reporting requirements</li>
        <li>New e-invoicing mandates</li>
        <li>Updated return filing procedures</li>
        <li>Stricter documentation requirements</li>
      </ul>

      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Impact on Businesses</h2>
      <p class="mb-4 text-lg leading-relaxed">These changes affect businesses in various ways:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Need for updated accounting systems</li>
        <li>Additional training requirements</li>
        <li>Changes in cash flow management</li>
        <li>New compliance deadlines</li>
      </ul>
    `,
    date: "March 15, 2024",
    category: "Tax Updates",
    readTime: "5 min read",
    author: "A.S. Dhruv",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    tags: ["GST", "Compliance", "Tax Updates", "Business"]
  },
  {
    id: "digital-transformation-accounting",
    title: "Digital Transformation in Accounting",
    excerpt: "How modern technology is reshaping the accounting industry and what it means for your business.",
    content: `
      <p class="mb-6 text-lg leading-relaxed">The accounting industry is undergoing a significant digital transformation, revolutionizing how businesses manage their finances and comply with regulations.</p>
      
      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Emerging Technologies in Accounting</h2>
      <p class="mb-4 text-lg leading-relaxed">Several technologies are reshaping the accounting landscape:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Cloud-based accounting software</li>
        <li>Artificial Intelligence and Machine Learning</li>
        <li>Blockchain for secure transactions</li>
        <li>Automated data processing</li>
      </ul>

      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Benefits of Digital Transformation</h2>
      <p class="mb-4 text-lg leading-relaxed">The advantages of embracing digital solutions include:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Improved accuracy and reduced errors</li>
        <li>Real-time financial insights</li>
        <li>Enhanced security and data protection</li>
        <li>Streamlined compliance processes</li>
      </ul>
    `,
    date: "March 10, 2024",
    category: "Technology",
    readTime: "4 min read",
    author: "A.S. Dhruv",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    tags: ["Technology", "Digital Transformation", "Accounting", "Innovation"]
  },
  {
    id: "tax-planning-small-businesses",
    title: "Tax Planning Strategies for Small Businesses",
    excerpt: "Essential tax planning strategies to optimize your business's financial position.",
    content: `
      <p class="mb-6 text-lg leading-relaxed">Effective tax planning is crucial for small businesses to optimize their financial position and ensure sustainable growth.</p>
      
      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Essential Tax Planning Strategies</h2>
      <p class="mb-4 text-lg leading-relaxed">Key strategies that small businesses should consider:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Proper business structure selection</li>
        <li>Strategic expense management</li>
        <li>Investment in tax-saving instruments</li>
        <li>Regular tax health check-ups</li>
      </ul>

      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Common Pitfalls to Avoid</h2>
      <p class="mb-4 text-lg leading-relaxed">Businesses should be aware of these common mistakes:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Missing important deadlines</li>
        <li>Inadequate record keeping</li>
        <li>Ignoring tax credits and deductions</li>
        <li>Poor documentation of expenses</li>
      </ul>
    `,
    date: "March 5, 2024",
    category: "Business",
    readTime: "6 min read",
    author: "A.S. Dhruv",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    tags: ["Tax Planning", "Small Business", "Finance", "Strategy"]
  }
]; 